module.exports = __webpack_public_path__ + "img/img-form-soluciones.de6f7754.webp";